var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entering-wrapper"},[_c('entering-step',{attrs:{"step":_vm.step,"stepOneText":"个人信息","stepTwoText":"线下首诊信息"}}),_vm._v(" "),_c('edit-first-record',{attrs:{"private-id":_vm.privateId,"doc-id":_vm.docId},on:{"success":_vm.success}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a9fa34a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/Entering/firstMedicalRecord.vue
// module id = null
// module chunks = 